import { observer } from 'mobx-react';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Box, Button, CircularProgress, Link, Typography } from '@mui/material';

import useStores from 'hooks/use-stores';

const useStyles = makeStyles()(() => ({
    root: {
        padding: 100,
        paddingTop: 100,
        background: '#FAFAFA',
        '@media (max-width: 1140px)': {
            padding: '100px 20px'
        }
    },
    header: {
        fontSize: 48,
        '@media (max-width: 1140px)': {
            textAlign: 'left'
        }
    },
    box: {
        maxWidth: 1200,
        margin: '0 auto'
    },
    link: {
        color: 'initial',
        display: 'flex',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    card: {
        width: 300,
        cursor: 'pointer',
        background: '#fff',
        boxShadow: '0px 10px 40px rgba(186, 184, 176, 0.2)',
        padding: 24,
        borderRadius: 28,
        transition: 'all 0.2s ease-out',
        '&:hover': {
            boxShadow: '0px 10px 40px rgba(186, 184, 176, 0.5)'
        },
        '@media (max-width: 480px)': {
            width: 'initial'
        },
        '@media (max-width: 1140px)': {
            marginBottom: 40,
            '&:nth-child(3)': {
                marginBottom: 20
            }
        }
    },
    image: {
        backgroundColor: '#C4C4C4',
        borderRadius: 18,
        marginBottom: 32,
        height: 180,
        width: 300,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        '@media (max-width: 480px)': {
            width: '100%'
        }
    },
    title: {
        fontSize: 20,
        fontWeight: 600,
        marginBottom: 16
    },
    subTitle: {
        fontSize: 16,
        color: '#979797'
    },
    button: {
        fontSize: 16,
        padding: '20px 40px',
        borderRadius: 100,
        borderColor: '#ff6600',
        '@media (max-width: 1140px)': {
            width: '100%'
        }
    }
}));

const Blog = () => {
    const { classes } = useStyles();
    const { blogStore } = useStores();
    return (
        <Box className={classes.root}>
            <Typography className={classes.header} align="center" variant="h2">
                {'Latest blog activities'}
            </Typography>
            {blogStore.isLoading ? (
                <CircularProgress />
            ) : (
                <Box
                    className={classes.box}
                    display="flex"
                    flexWrap="wrap"
                    flexDirection="row"
                    justifyContent="space-around"
                    pb={10}
                    pt={8}
                >
                    {blogStore.posts.map(({ title, date, timeToRead, image, link }, index) => (
                        <Link key={index} href={link} target="_blank" className={classes.link}>
                            <Box className={classes.card}>
                                <div className={classes.image} style={{ backgroundImage: `url(${image})` }} />
                                <Typography className={classes.title} variant="h3">
                                    {title}
                                </Typography>
                                <Typography className={classes.subTitle} variant="subtitle1">
                                    {date} • {timeToRead}
                                </Typography>
                            </Box>
                        </Link>
                    ))}
                </Box>
            )}

            <Box textAlign="center">
                <Button
                    href="https://vulners.com/blog"
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    className={classes.button}
                >
                    {'Read All Blog Activities'}
                </Button>
            </Box>
        </Box>
    );
};

export default observer(Blog);
